import { render, staticRenderFns } from "./CsServicioIndex.vue?vue&type=template&id=fdf132be"
import script from "./CsServicioIndex.vue?vue&type=script&lang=js"
export * from "./CsServicioIndex.vue?vue&type=script&lang=js"
import style0 from "./CsServicioIndex.vue?vue&type=style&index=0&id=fdf132be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports